import WorldSystem from '../WorldSystem';
import AnimationTask from '../../../Utility/Task/AnimationTask';
import GameObject from '../../../GameObject/GameObject';
import PopupTask from '../../../Utility/Task/PopupTask';
import SendCoinsTask from '../../../Utility/Task/SendCoinsTask';
import { IPlayerState, IPlayerStateTaskData } from '../../../State/Player/IPlayerState';
import StarChestFTUXTask from '../../../Utility/Task/StarChestFTUXTask';
import QuestsFTUXTask from '../../../Utility/Task/QuestsFTUXTask';
import PetFTUXTask from '../../../Utility/Task/PetFTUXTask';
import ShowWheelTask from 'Utility/Task/ShowWheelTask';
import WheelFTUXTask from 'Utility/Task/WheelFTUXTask';
import PetWalkTask from 'Utility/Task/PetWalkTask';
import HarvestTask from 'Utility/Task/HarvestTask';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { ShowFTUXFieldUnlock } from 'System/Animation/Clip';
import WorldUISystem from 'System/UI/WorldUISystem';
import FarmBtnFTUXTask from 'Utility/Task/FarmBtnFTUXTask';
import EventFTUXTask from 'Utility/Task/EventFTUXTask';
import { PlayerTask } from 'State/Player/PlayerTasks';
import { PlayerStateHelper } from 'State/Player/PlayerStateHelper';
import { ShowQuestProgressEvent } from 'Prefabs/UI/HUD/Quests/QuestButton';
import System from 'System/System';
import ContextTask from 'Utility/Task/ContextTask';
import SeasonPassFTUXTask from 'Utility/Task/SeasonPassFTUXTask';

export default class WorldTaskHelper {
    public static iconHop(system: WorldSystem, levelNumber: number): void {
        system.taskQueue.queueNext(
            new AnimationTask(
                'PlayerIconHop',
                system.worldMap.playerIcon,
                { nextNode: system.getLevelNode(levelNumber) },
                true
            )
        );
    }
    public static FTUXFieldUnlock(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        const worldHudHandler = system.scene.getSystem(WorldUISystem).hud;
        const worldHUD = GameObject.findByName('worldHUD_main_element')[0];

        system.taskQueue.queue(
            new AnimationClipTask(
                new ShowFTUXFieldUnlock(worldHUD, {
                    harvestButton: worldHudHandler.harvestButton,
                    mainContainer: worldHudHandler.mainContainer,
                })
            )
        );
    }

    public static QueuePopup(system: System, taskData: IPlayerStateTaskData): void {
        const queueFunc = taskData.queueNext
            ? system.taskQueue.queueNext.bind(system.taskQueue)
            : system.taskQueue.queue.bind(system.taskQueue);
        queueFunc(new PopupTask(system, taskData));
    }
    public static SendCoins(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new SendCoinsTask(taskData));
    }
    public static StarChestFTUX(system: WorldSystem, taskData: { starChestLevel: number }): void {
        system.taskQueue.queue(new StarChestFTUXTask(taskData.starChestLevel));
    }
    public static QuestFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new QuestsFTUXTask());
    }
    public static SeasonPassFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
    }
    public static PetUnlockFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new PetFTUXTask(taskData.petLevel, taskData.petId));
    }
    public static PetWalk(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(
            new PetWalkTask(taskData.currentWorldMaxLevel, taskData.endLevel, taskData.startLevel, taskData.petId)
        );
    }
    public static ShowWheel(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(
            new ShowWheelTask(taskData.luckyWheel)
        );
    }
    public static WheelFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new WheelFTUXTask(taskData.firstWheelLevel));
    }
    public static Harvest(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new HarvestTask(taskData.rewardData, taskData.coinAmount, taskData.playAutoFlow));
    }
    public static FarmBtnFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new FarmBtnFTUXTask());
    }
    public static EventFTUX(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new EventFTUXTask());
    }
    public static ContextTask(system: WorldSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new ContextTask(taskData.contextType, taskData.data));
    }
    public static *executeTask(system: WorldSystem, state: IPlayerState, taskData: IPlayerStateTaskData) {
        switch (taskData.task) {
            case PlayerTask.ICON_HOP:
                WorldTaskHelper.iconHop(system, taskData.levelNumber);
                break;
            case PlayerTask.FIELD_FTUX:
                const closingTask = state.tasks.find(task => PlayerStateHelper.isClosingTask(task));

                if (closingTask) {
                    closingTask.delay = 4000;
                }
                WorldTaskHelper.FTUXFieldUnlock(system, taskData);
                break;
            case PlayerTask.SHOW_POPUP:
                WorldTaskHelper.QueuePopup(system, taskData);
                break;
            case PlayerTask.SEND_COINS:
                WorldTaskHelper.SendCoins(system, taskData);
                break;
            case PlayerTask.STAR_CHEST_FTUX:
                WorldTaskHelper.StarChestFTUX(system, taskData as { starChestLevel: number });
                break;
            case PlayerTask.QUESTS_FTUX:
                WorldTaskHelper.QuestFTUX(system, taskData);
                break;
            case PlayerTask.SEASON_PASS_FTUX:
                WorldTaskHelper.SeasonPassFTUX(system, taskData);
                break;
            case PlayerTask.SHOW_QUEST_PROGRESS:
                system.scene.emit(ShowQuestProgressEvent, taskData);
                break;
            case PlayerTask.PET_WALK:
                WorldTaskHelper.PetWalk(system, taskData);
                break;
            case PlayerTask.PET_FTUX:
                WorldTaskHelper.PetUnlockFTUX(system, taskData);
                break;
            case PlayerTask.SHOW_WHEEL:
                WorldTaskHelper.ShowWheel(system, taskData);
                break;
            case PlayerTask.WHEEL_FTUX:
                WorldTaskHelper.WheelFTUX(system, taskData);
                break;
            case PlayerTask.HARVEST:
                WorldTaskHelper.Harvest(system, taskData);
                break;
            case PlayerTask.FARM_BTN_FTUX:
                WorldTaskHelper.FarmBtnFTUX(system, taskData);
                break;
            case PlayerTask.EVENT_FTUX:
                WorldTaskHelper.EventFTUX(system, taskData);
                break;
            case PlayerTask.CONTEXT_TASK:
                WorldTaskHelper.ContextTask(system, taskData);
                break;
        }
    }
}
